export default "__VITE_ASSET__f39ba78d__"